'use strict';

import React from 'react';
import FaClose from 'react-icons/lib/fa/close'

class PrivacyPolicy extends React.Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.classes = this.classes.bind(this);
    
    this.state = {
      showModal: false
    }
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: !this.state.showModal });
  }

  classes() {
    return `privacy-policy-screen ${this.state.showModal ? 'visible' : ''}`;
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    //console.log(`${name} -> ${target.type}`)
    if (target.type == 'checkbox') {
      this.setState({
        [name]: target.checked ? true : false
      });
    } else {
      this.setState({
        [name]: target.value
      });
    }
    //console.log(`${name} -> ${target.checked}`)
    //console.log(this.state)
  }

  handleExtraChange(event) {
    const target = event.target;
    const name = target.name;
    //console.log(`${name} -> ${target.type}`)
    if (target.type == 'checkbox') {
      let options = this.state.availableExtra
      //console.log(options)
      options[name].selected = target.checked ? true : false
      this.setState({
        ['availableExtra']: options
      });
    }
    //console.log(`${name} -> ${target.checked}`)
    //console.log(this.state)
  }

  render() {
    /*const popover = (
      <Popover id="modal-popover" title="popover">
        very popover. such engagement
      </Popover>
    );
    const tooltip = (
      <Tooltip id="modal-tooltip">
        wow.
      </Tooltip>
    );*/

    return (
      <div>
        <div className={this.classes()}>
          <button
            className="privacy-policy-link"
            onClick={this.open}>
            Política de Privacidade
          </button>
          <div className="body">
            <button className="close-button" onClick={this.close}><FaClose /></button>
            <div className="section-content">
              <h2 className="title section-title" style={{width: 'auto', fontSize: '40px', color: '#416cae'}}>Política de Privacidade</h2>
              <section>
                <h3 className="about-title">
                  QUE TIPO DE INFORMAÇÕES RECOLHEMOS
                </h3>
                <p>
                  Podem ser solicitadas informações pessoais, como o seu nome e o seu endereço de correio electrónico. As informações supra podem ser solicitadas quando se inscreve ou preenche formulário de contacto quer como trabalhador, candidato a emprego, formando, formador, cliente, fornecedor, visitante, etc.
                </p>
                <p>
                  Utilizamos “cookies” para recolher informações acerca das suas visitas ao nosso Web site e para melhorar a sua experiência. Pode encontrar mais informações acerca da forma como utilizamos cookies na secção infra “Utilização de cookies”.
                </p>
              </section>
              <section>
                <h3 className="about-title">UTILIZAÇÃO DAS INFORMAÇÕES DOS VISITANTES</h3>
                <p>Todas as informações pessoais que obtemos serão registadas, utilizadas e protegidas em conformidade com legislação comunitária vigente em matéria de protecção de dados e com esta política de privacidade.</p>
              </section>
              <section>
                <h3 className="about-title">PROTECÇÃO DAS INFORMAÇÕES DOS VISITANTES</h3>
                <p>As informações que nos fornece ao visitar o nosso Web site, estão protegidas no âmbito da implementação das várias medidas de segurança, nomeadamente através de acesso condicionado, e da salvaguardada de confidencialidade das informações.</p>
                <p>Alertamos contudo que ao fornecer informações pessoais online, existe um risco de terceiros poderem interceptar e utilizar estas informações, pelo que em termos de segurança de qualquer informação que divulgue online; fá-lo-á por sua própria conta e risco.</p>
              </section>
              <section>
                <h3 className="about-title">PRIVACIDADE DE MENORES (CRIANÇAS E  JOVENS)</h3>
                <p>A TOC TO ME está empenhada em proteger a privacidade de crianças e não pretende recolher dados pessoais de menores com idade inferior a 13 anos (A idade legalmente definida em termos de lei nacional no âmbito do RGPD). Se o utilizador for uma criança com idade inferior a 13 anos e tentar enviar o seu registo, o mesmo será rejeitado e a criança será informada de que não aceitamos registos provenientes de crianças com idade inferior a 13 anos. Incentivamos os pais e os responsáveis por menores com idade inferior a 13 anos a controlarem e supervisionarem regularmente a utilização do correio electrónico e as outras actividades online das crianças.</p>
              </section>
              <section>
                <h3 className="about-title">UTILIZAÇÃO DE COOKIES</h3>
                <p>Caso pretenda poderá desactivar todos os cookies, caso prefira não os receber. Também pode fazer com que o seu computador o avise da utilização de cookies. Em ambos os casos, tem de ajustar as definições do seu navegador (como o Internet Explorer).</p>
              </section>
              <section>
                <h3 className="about-title">RECTIFICAÇÃO, ELIMINAÇÃO OU MODIFICAÇÃO OU ACTUALIZAÇÃO DE INFORMAÇÕES PESSOAIS</h3>
                <p>A TOC TO ME não armazena quaisquer informações pessoais dos utilizadores do seu site.</p>
              </section>
              <section>
                <h3 className="about-title">NOSSO CONTACTO</h3>
                <p>Se tiver quaisquer perguntas ou comentários relativamente ao nosso Web site e/ou à nossa política de privacidade, escreva-os para o endereço presente no nosso website.</p>
              </section>
              <section>
                <h3 className="about-title">O CONSENTIMENTO DO TITULAR DOS DADOS</h3>
                <p>Ao utilizar o nosso Web site confirma que aceita os termos desta Política de Privacidade, assim como os nossos Termos e Condições. Caso não concorde com os termos da nossa Política de Privacidade e os nossos Termos e Condições, solicita-se que não nos forneça informações pessoais e cesse a utilização no nosso Web site.</p>
              </section>
              <section>
                <h3 className="about-title">DIREITO DO TITULAR DOS DADOS AO ACESSO ÀS SUAS INFORMAÇÕES PESSOAIS</h3>
                <p>A TOC TO ME não armazena quaisquer dados pessoais dos utilizadores do seu site.</p>
              </section>
              <section>
                <h3 className="about-title">DIREITO DO TITULAR DOS DADOS À ELIMINAÇÃO DE DADOS PESSOAIS</h3>
                <p>A TOC TO ME não armazena quaisquer dados pessoais dos utilizadores do seu site.</p>
              </section>
              <section>
                <h3 className="about-title">POLITICA DE PRIVACIDADE</h3>
                <p>A política de privacidade online aplica-se apenas às informações recolhidas através do nosso Web site e não às informações recolhidas offline.</p>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PrivacyPolicy.displayName = 'PrivacyPolicy';

// Uncomment properties you need
// ContactForm.propTypes = {};
// ContactForm.defaultProps = {};

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.js